module.exports = __webpack_public_path__ + "static/media/to.74048caf.png";